import { merge } from 'lodash-es';
import { type PropsWithChildren, useContext } from 'react';

import { TreeMapChartConfigContext } from '../context/TreeMapConfigContext.js';
import { defaultTreeMapConfig } from '../defaults.js';
import type {
  TreeMapConfig,
  TreeMapContextConfig,
} from '../types/treemap-chart.config.js';
import type { TreeMapHierarchicalProps } from '../types/treemap.js';
import { buildTreeMapChartConfig } from '../utils/build-tree-map-chart-config.js';
import { iterateSlots } from '../utils/iterate-slots.js';

export function deserializeConfig(
  serializedConfig: string,
): TreeMapContextConfig {
  try {
    return merge({}, defaultTreeMapConfig, JSON.parse(serializedConfig));
  } catch {
    return defaultTreeMapConfig;
  }
}

export const useTreeMapChartConfig = (
  // eslint-disable-next-line @typescript-eslint/no-deprecated
  props: PropsWithChildren<TreeMapHierarchicalProps>,
): TreeMapConfig => {
  const { children } = props;

  const contextConfig = useContext(TreeMapChartConfigContext);

  const slots = iterateSlots(children);

  const isImportedConfig = typeof contextConfig === 'string';

  const config = isImportedConfig
    ? deserializeConfig(contextConfig)
    : contextConfig;

  return buildTreeMapChartConfig(props, config, slots);
};
